import { Drawer } from "@/components";
import FormEdit from "./FormEdit";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  roomId: number;
}

const RoomEditDrawer = ({ open, setOpen, roomId }: Props) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      label="事前相談の 編集"
      description={`事前相談はこちらから。事務局で確認した後、ご連絡します。\n（平日の9:00-17:00まで。それ以外の日時では回答が翌営業日以降になることがあります）`}
      size="large"
      disableBackdropClick
    >
      <FormEdit onClose={handleClose} roomId={roomId} />
    </Drawer>
  );
};

export default RoomEditDrawer;
